import { render, staticRenderFns } from "./RefOrders.vue?vue&type=template&id=75a1653c&scoped=true&"
import script from "./RefOrders.vue?vue&type=script&lang=js&"
export * from "./RefOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a1653c",
  null
  
)

export default component.exports